// extracted by mini-css-extract-plugin
export default {"panel":"EditPropertyHoldingPanel_panel__l6e7+","panelContent":"EditPropertyHoldingPanel_panelContent__2Z4qr","panelTitle":"EditPropertyHoldingPanel_panelTitle__oEBvX"};